import{gql as e}from"graphql-tag";const o=e`
    fragment coach on CoachNode {
  uuid
  firstName
  lastName
  avatar
  providerType
  providerSchedulingType
  psychiatristSubtype
}
    `,r=e`
    fragment member on MemberNode {
  uuid
  firstName
  lastName
  avatar
}
    `,s=e`
    fragment messageMeditationResource on MeditationNode {
  uuid
  duration
  image
  name
  mediaType {
    icon
  }
}
    `,t=e`
    fragment messageProgramResource on ProgramNode {
  uuid
  duration
  image
  name
  mediaType {
    icon
  }
}
    `,n=e`
    fragment messageResource on MessageResourceNode {
  uuid
  order
  meditationId
  programId
  companyAdditionalBenefitId
  meditation {
    ...messageMeditationResource
  }
  program {
    ...messageProgramResource
  }
}
    `,m=e`
    fragment message on MessageNode {
  uuid
  conversationUuid
  senderUuid
  receiverUuid
  content
  sentAt
  readAt
  messageResources {
    ...messageResource
  }
}
    `,i=e`
    fragment conversation on ConversationNode {
  uuid
  active
  createdAt
  coach {
    ...coach
  }
  member {
    ...member
  }
  newestMessage {
    ...message
  }
}
    `;export{o as CoachFragmentDoc,i as ConversationFragmentDoc,r as MemberFragmentDoc,m as MessageFragmentDoc,s as MessageMeditationResourceFragmentDoc,t as MessageProgramResourceFragmentDoc,n as MessageResourceFragmentDoc};
//# sourceMappingURL=fragments.generated.es.js.map
